export const DealerPosition = {
  OWNER: 'OWNER',
  SALES_MANAGER: 'SALES_MANAGER',
  BUYER: 'BUYER',
  OTHER: 'OTHER',
};

export const DealerPositionName = {
  OWNER: 'Owner',
  SALES_MANAGER: 'Sales Manager',
  BUYER: 'Buyer',
  OTHER: 'Other',
};
